var resetPswRequest;
(function (resetPswRequest) {
    document.addEventListener('ControllerReady', () => {
        const $first = document.querySelector('#first');
        const $second = document.querySelector('#second');
        const $errordiv = document.querySelector('#errorDiv');
        const $errorLab = document.querySelector('#errorLabel');
        let email;
        const config = retrieveConfig(document);
        const getServicesEndpoint = `/api/esb/user/sendResetPasswordCode?_format=form`;
        const resetPwdForm = document.querySelector('.reset-psw-req-Form');
        let dropDownCoop = resetPwdForm.querySelector('[name="cooperativaSelect"]');
        let emailSent = document.querySelector('[name="emailSent"]');
        let coopId;
        presetCooperativa(document);
        resetPwdForm.addEventListener('submit', handleFormSubmit);
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config)
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function retrieveEmail($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.reset-psw-req-Form');
            if ($form) {
                try {
                    data = $form.querySelector('[name="email"]').value;
                }
                catch (e) {
                    console.log('Error during retrieval of parameter for current service. %s', e);
                }
            }
            return data;
        }
        function handleFormSubmit(event) {
            event.preventDefault();
            let device = "web";
            email = retrieveEmail(document);
            var url = { email, device, coopId };
            $first.setAttribute('data-spinner', 'mask');
            Fetch(getServicesEndpoint, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                }
            }).then(response => {
                if (response.header.result == 'OK') {
                    hideDiv();
                    emailSent.innerHTML = email;
                }
                else {
                    var message = response.header.errorMessage;
                    $errorLab.innerHTML = message;
                    $errordiv.classList.remove('hidden');
                }
                $first.removeAttribute('data-spinner');
            }).catch(err => {
                console.error('Error: ', err);
                $first.removeAttribute('data-spinner');
            });
        }
        function hideDiv() {
            $first.classList.add('hidden');
            $second.classList.remove('hidden');
        }
        function presetCooperativa(form) {
            const urlParams = new URLSearchParams(window.location.search);
            const cooperativaCode = urlParams.get('cooperativa');
            let cooperativa = urlParams.get('cpvName');
            if (cooperativaCode && !isNaN(parseInt(cooperativaCode))) {
                coopId = cooperativaCode;
                let $filter;
                switch (cooperativaCode) {
                    case '35': 
                        $filter = form.querySelector('.CA3');
                        $filter.classList.remove('hidden');
                        break;
                    case '9': 
                        $filter = form.querySelector('.CCI');
                        $filter.classList.remove('hidden');
                        break;
                    case '22': 
                        $filter = form.querySelector('.CAM');
                        $filter.classList.remove('hidden');
                        break;
                    case '44': 
                        $filter = form.querySelector('.DRM');
                        $filter.classList.remove('hidden');
                        break;
                    case '36': 
                        $filter = form.querySelector('.CTR');
                        $filter.classList.remove('hidden');
                        break;
                    case '3': 
                        $filter = form.querySelector('.CLO');
                        $filter.classList.remove('hidden');
                        break;
                    case '1': 
                        $filter = form.querySelector('.NOVA');
                        $filter.classList.remove('hidden');
                        break;
                    case '7': 
                        $filter = form.querySelector('.CFI');
                        $filter.classList.remove('hidden');
                        break;
                    case '8': 
                        $filter = form.querySelector('.CTI');
                        $filter.classList.remove('hidden');
                        break;
                    case '2': 
                        $filter = form.querySelector('.CLI');
                        $filter.classList.remove('hidden');
                        break;
                    case '15': 
                        $filter = form.querySelector('.CRO');
                        $filter.classList.remove('hidden');
                        break;
                    case '22': 
                        $filter = form.querySelector('.CAM');
                        $filter.classList.remove('hidden');
                        break;
                    case '44': 
                        $filter = form.querySelector('.DRM');
                        $filter.classList.remove('hidden');
                        break;
                    case '36': 
                        $filter = form.querySelector('.CTR');
                        $filter.classList.remove('hidden');
                        break;
                    default:
                        $filter = form.querySelector('.DEFAULT');
                        $filter.classList.remove('hidden');
                        break;
                }
                document.querySelector('#defaultCpvApp').innerHTML = cooperativa.replace('-', ' ');
            }
        }
    });
})(resetPswRequest || (resetPswRequest = {}));
;
